import DataConst from 'consts/DataConst';

export default {
  name: DataConst.MODELS.IMPORT_ORDER,
  primaryKey: 'id',
  properties: {
    id: 'int',
    orderItems: 'OrderItem[]',
    note: 'string?',
    money: 'int',
    surcharge: 'int?',
    provider: DataConst.MODELS.PROVIDER,
    createdAt: 'date',
    updatedAt: 'date?'
  }
};
